import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChevronRight, LayoutDashboard } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

/** A dashboard to add to: tap to choose it. */
export const ChoiceRow = memo(
  ({
    name,
    hint,
    disabled,
    onPress,
  }: {
    name: string;
    /** e.g. 最匹配, on the first suggestion. */
    hint?: string;
    disabled: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={`加到「${name}」`}
        accessibilityState={{ disabled }}
        disabled={disabled}
        onPress={onPress}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(10),
          paddingHorizontal: rpx(12),
          paddingVertical: rpx(10),
          borderRadius: rpx(11),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: pressed ? aiColors.muted : aiColors.card,
          opacity: disabled ? 0.55 : 1,
        })}
      >
        <View
          style={{
            width: rpx(28),
            height: rpx(28),
            borderRadius: rpx(8),
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: tint(aiColors.amber, 0.14),
          }}
        >
          <LayoutDashboard size={15} color={aiColors.amber} />
        </View>
        <Typography.Text
          size={rpx(14)}
          color={aiColors.foreground}
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {name}
        </Typography.Text>
        {hint ? (
          <Typography.Text size={rpx(11)} color={aiColors.primary}>
            {hint}
          </Typography.Text>
        ) : null}
        <ChevronRight size={16} color={aiColors.mutedForeground} />
      </Pressable>
    );
  },
);
